/*
 * @Description  : 加载 wsl-xxx 库
 * @usage        : 由于 wsl-xxx 库设计之初没有考虑在 SSR 阶段使用，所以直接访问了浏览器的 api，这里需要在 CSR 阶段才加载
 * @Date         : 2021-10-09 14:39:59
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @FilePath: /vise/packages/app-share/src/utils/load-wslib.ts
 */
import { IS_SSR } from '@/utils/env';

/**
 * 获取 @tencent/wsl-wx
 *
 * @export
 * @return {*}
 */
export async function loadWslWxAsync() {
  if (IS_SSR) return;
  try {
    return await import('@tencent/wsl-wx');
  } catch (err) {
    console.error('[loadWslWxAsync] error: ', err);
    return;
  }
}

/**
 * 获取 @tencent/wsl-ajax
 *
 * @export
 * @return {*}
 */
export async function loadWslAjaxAsync() {
  if (IS_SSR) return;

  try {
    return await import('@tencent/wsl-ajax');
  } catch (err) {
    console.error('[loadWslAjaxAsync] error: ', err);
    return;
  }
}

/**
 * 获取 @tencent/wsl-report
 *
 * @export
 * @return {*}
 */
export async function loadWslReportAsync() {
  if (IS_SSR) return ;

  try {
    return await import('@tencent/wsl-report');
  } catch (err) {
    console.error('[loadWslReportAsync] error: ', err);
    return;
  }
}

/**
 * 获取 @tencent/wsl-schema
 *
 * @export
 * @return {*}
 */
export async function loadWslSchemaAsync() {
  if (IS_SSR) return;

  try {
    return await import('@tencent/wsl-schema');
  } catch (err) {
    console.error('[loadWslSchemaAsync] error: ', err);
    return;
  }
}

/**
 * 获取 @tencent/wesee-clipboard
 *
 * @export
 * @return {*}
 */
export async function loadWeseeClipboardAsync() {
  if (IS_SSR) return;

  try {
    return await import('@tencent/wesee-clipboard');
  } catch (err) {
    console.error('[loadWeseeClipboardAsync] error: ', err);
    return;
  }
}

/**
 * 获取 @tencent/ws-url
 *
 * @export
 * @return {*}
 */
export async function loadWslUrlAsync() {
  if (IS_SSR) return;

  try {
    return await import('@tencent/wsl-url');
  } catch (err) {
    console.error('[loadWslUrl] error: ', err);
    return;
  }
}

/**
 * 获取 @tencent/wsl-share
 *
 * @export
 * @return {*}
 */
export async function loadWslShareAsync() {
  if (IS_SSR) return;

  try {
    return await import('@tencent/wsl-share');
  } catch (err) {
    console.error('[loadWslShare] error: ', err);
    return;
  }
}
